module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "zk-steps",
    class: ['is-' + _vm.direction]
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.11.1.4@vue-loader/lib/template-compiler.js?{"id":"data-v-6a2c8ed9"}!./~/.11.1.4@vue-loader/lib/selector.js?type=template&index=0!./src/packages/steps/src/steps.vue
// module id = 265
// module chunks = 0